import React from 'react';
import { hooks, signaling, constants as c } from '@lifesize/clients.sdk';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { featureSelectors, media } from '@lifesize/nucleus';
import PresentationButton from 'components/InCall/InCallFooterButtons/PresentationButton';
import actions from 'actions/PresentationActions';
import _get from 'lodash/get';
import { FLAG_PRESENTATION_RESTRICTION } from 'constants/FeatureFlags';

const mapDispatchToProps = dispatch => ({
  onStopPresentationClick: () => media.stopPresentation(),
  showPresentationSelection: () => dispatch(actions.showPresentationSelection())
});

const mapStateToProps = (state, ownProps) => {
  const presenter = ownProps.presenter;
  const presenterName = presenter ? presenter.name : null;
  const presentationRestrictionFlagEnabled = featureSelectors.getFeatureFlag(state)(FLAG_PRESENTATION_RESTRICTION);

  return {
    ...ownProps,
    isConnected: ownProps.isConnected,
    presenterName,
    isDisabled: ownProps.isRemotePresentationExists || !ownProps.canPresent,
    isPresenting: !!ownProps.isPresenting,
    presentationRestrictionFlagEnabled
  };
};

const ConnectedComponent = injectIntl(connect(mapStateToProps, mapDispatchToProps)(PresentationButton));

const FunctionalWrapper = (props) => {
  const presenter = hooks.usePresentingParticipant() || {};
  const mediaState = hooks.useMedia();
  const isConnected = hooks.useCallConnected();
  const isPresenting = !!mediaState.localPresentationStream;
  const currentUser = hooks.useCurrentUserParticipant() || {};
  const isRemotePresentationExists = mediaState.remotePresentationStream && isConnected;
  const conferenceInfo = signaling.selectors.conferenceInfo() || {};
  const isModerator = hooks.useIsCurrentUserModerator();
  const presentationRestriction = hooks.usePresentationRestriction();
  const { ownerUuid, lecturerUuid } = conferenceInfo
  const isOwner = ownerUuid === presenter.uuid || ownerUuid === currentUser.uuid;
  const isLecturer = lecturerUuid === presenter.uuid || currentUser.uuid === lecturerUuid ;
  return (<ConnectedComponent {...props}
      isRemotePresentationExists={isRemotePresentationExists}
      canPresent={_get(currentUser, 'canPresent')}
      isPresenting={isPresenting}
      isConnected={!!isConnected}
      presenter={presenter} conferenceType={conferenceInfo.type}
      isModerator={isModerator}
      isOwner={isOwner}
      isLecturer={isLecturer}
      mediaState={mediaState}
      isPresentationRestricted={presentationRestriction === c.PresentationRestriction.restrictedShare}
  />);
};

export {
  ConnectedComponent as PresentationButtonContainer
}
export default FunctionalWrapper;
